import { Navigate } from "react-router";
import { useGetLogQuery } from "../../../apis/Log.api";
import { PrimaryLog, Log } from "../../../types/models/Log";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const LogScoped = () => {
    const {
        data,
    } = useGetLogQuery(PrimaryLog.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/logs/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default LogScoped;
